
const mixinCommon = {
  data () {
    return {
      //dialog宽度
      dialogLargetW: '970px',
      dialogMiddleW: '730px',
      dialogSmallW: '630px',
      dialogDelW: '360px',
      dialogUploadW: '420px',
      dialogUploadM: '500px',
      //dialog中table的最大高度
      dialogTableH: '300',
      // 申报和计提新增弹框最大值
      dialogAdddW: '618px',
      dialogMAXLargetW: '1200px',
    }
  },
  methods: {
    //固定table表头
    maxTableHeight () {
      let self = this;
      this.$nextTick(() => {
        if (document.getElementsByClassName("tablediv") && document.getElementsByClassName(
          "tablediv"
        )[0]) {
          this.maxHeight = document.getElementsByClassName(
            "tablediv"
          )[0].offsetHeight;
        }
        // 通过捕获系统的onresize事件触发去改变原有的高度
        window.onresize = function () {
          if (document.getElementsByClassName("tablediv") && document.getElementsByClassName(
            "tablediv"
          )[0]) {
            self.maxHeight = document.getElementsByClassName(
              "tablediv"
            )[0].offsetHeight;
          }
        };
      })
    }
  }
}

export default mixinCommon;



// WEBPACK FOOTER //
// ./src/mixin/common.js